import React from "react"
import { Box } from "@mui/material"
import Button from "components/Buttons/Button"
import useToggle from "@secureo/common/hooks/useToggle"

import Icon from "@mdi/react"
import { mdiChevronDown, mdiChevronUp } from "@mdi/js"

const Description = ({ description }: Props) => {
	const [isOpen, toggleIsOpen] = useToggle()
	if (!description) return null

	return (
		<>
			<Box
				my={5}
				p={3}
				style={{
					boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.15)",
					height: isOpen ? 500 : "auto",
					overflow: isOpen ? "hidden" : "visible",
				}}
				dangerouslySetInnerHTML={{ __html: description }}
			></Box>
			<Box style={{ width: 250, margin: "auto" }}>
				<Button color="link-no-underline" onClick={toggleIsOpen}>
					{isOpen ? "Weiter lesen" : "Weniger anzeigen"}{" "}
					<Icon path={isOpen ? mdiChevronDown : mdiChevronUp} size={1} color="black" />
				</Button>
			</Box>
		</>
	)
}

interface Props {
	description: string
}

export default Description
